import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { ResetPasswordRequest } from '@/types/request/ResetPasswordRequest';

const useResetPassword = () => {
  const client = supabaseClient;

  const mutationFn = async (request: ResetPasswordRequest) => {
    return resetPassword(client, request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useResetPassword;

async function resetPassword(client: SupabaseClient, request: ResetPasswordRequest): Promise<void> {
  const { error } = await client.auth.updateUser({
    password: request.password,
  });

  if (error) throw new Error(error.message);
}
